export default "__VITE_ASSET__CTIGVvH___"